import {createSelector} from 'reselect'
import messageResource from '../../messageResource'
import {COUNTER, DURATION, THRESHOLD} from './constants'

export const getLockoutPolicyState = state => state.lockoutPolicy

export const isUseLockoutPolicy = state => getLockoutPolicyState(state).useLockoutPolicy
export const getDuration = state => getLockoutPolicyState(state).duration
export const getThreshold = state => getLockoutPolicyState(state).threshold
export const getCounter = state => getLockoutPolicyState(state).counter
export const isModified = state => getLockoutPolicyState(state).isModified
export const getUnlockAllStatus = state => getLockoutPolicyState(state).unlockAllStatus

export const getDurationErrorMessage = createSelector(
    getDuration,
    getThreshold,
    getCounter,
    (duration, threshold, counter) => {
        if (!duration || (duration < DURATION.min || duration > DURATION.max)) {
            return messageResource.getMessage('lockout_policy.settings.error_message.not_in_bounds', [DURATION.min, DURATION.max])
        }
        if (!!threshold && counter && duration < counter) {
            return messageResource.getMessage('lockout_policy.settings.error_message.duration_and_threshold')
        }
    }
)

export const getThresholdErrorMessage = createSelector(
    getThreshold,
    (threshold) => {
        if ((!threshold && threshold !== 0) || (!!threshold && (threshold < THRESHOLD.min || threshold > THRESHOLD.max))) {
            return messageResource.getMessage('lockout_policy.settings.error_message.not_in_bounds', [THRESHOLD.min, THRESHOLD.max])
        }
    }
)

export const getCounterErrorMessage = createSelector(
    getDuration,
    getThreshold,
    getCounter,
    (duration, threshold, counter) => {
        if (!counter || counter < COUNTER.min || counter > COUNTER.max) {
            return messageResource.getMessage('lockout_policy.settings.error_message.not_in_bounds', [COUNTER.min, COUNTER.max])
        }
        if (!!threshold && counter && duration !== 0 && duration < counter) {
            return messageResource.getMessage('lockout_policy.settings.error_message.duration_and_threshold')
        }
    }
)

export const getLockoutPolicyObject = createSelector(
    isUseLockoutPolicy,
    getDuration,
    getThreshold,
    getCounter,
    (enabled, durationMinutes, threshold, resetCounterAfter) => ({
        enabled, durationMinutes, threshold, resetCounterAfter
    })
)



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/selectors.js